"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_CONST = void 0;
exports.DATE_CONST = {
    COMMON_FORMAT: "MM/yyyy",
};
